import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { QrReader } from 'react-qr-reader';

function WifiQRScanner() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const [data, setData] = useState('No QR code detected');
  const [isCameraActive, setIsCameraActive] = useState(true);

  const handleBack = () => {
    setIsCameraActive(false);
    navigate(-1);
  };

  const parseWifiQR = (qrText) => {
    const regex = /^WIFI:S:(.*?);T:(.*?);P:(.*?);;/;
    const match = qrText.match(regex);
    if (match) {
      const ssid = match[1];
      const password = match[3];
      return { ssid, password };
    }
    return null;
  };

  const handleScan = (result) => {
    if (result) {
      setData(result.text);
      const wifiData = parseWifiQR(result.text);

      if (wifiData) {
        const { ssid, password } = wifiData;
        setIsCameraActive(false);
        navigate(-1, { state: { ssid, password } });
      } else {
        console.error('Invalid QR format');
      }
    }
  };

  const handleError = (error) => {
    console.error(isCameraActive, error);
  };

  useEffect(() => {
    return () => {
      setIsCameraActive(false);
    };
  }, []);

  return (
    <div className="sm-page">
      <div className="sm-container">
        <div className="header">
          <button onClick={handleBack} className="back-button">&#8592;</button>
          <h1>{translations.qr_scanner}</h1>
        </div>
        <div className="content">
          <QrReader
            onResult={handleScan}
            onError={handleError}
            constraints={{
              facingMode: 'environment'
            }}
            className="QrReader"
          />
        </div>
      </div>
    </div>
  );
}

export default WifiQRScanner;
